import { Route, Routes } from 'react-router-dom';

import { SettingsTemplatesView } from './settingsTemplates.view';
import { SettingsTemplatesAutoReplyView } from './views/settingsTemplatesAutoReply.view';
import { SettingsTemplatesQuickResponseView } from './views/settingsTemplatesQuickResponse.view';

export const SettingsTemplatesRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route path="*" element={<SettingsTemplatesView />}>
        <Route index element={<SettingsTemplatesQuickResponseView />} />
        <Route
          path="quick-response"
          element={<SettingsTemplatesQuickResponseView />}
        />
        <Route path="auto-reply" element={<SettingsTemplatesAutoReplyView />} />
      </Route>
    </Routes>
  );
};
